/* Portal Copy Enable — re-enable text selection on portal pages */
(function(){
  /* CSS override only — force user-select: text on all elements */
  function enableCopy() {
    var b = document.body;
    if (b) {
      b.style.userSelect = 'text';
      b.style.webkitUserSelect = 'text';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enableCopy);
  } else {
    enableCopy();
  }
})();
